import React, { useEffect } from 'react';
import { useSideMenuContext } from '../../../SideMenuContext';
import { screenSizeSwitch } from '../../../lib/helpers';
import Footer from '../Footer';
import Div from '../../../components/Div';
import { Col, Container, Row } from '../../../components/TheGrid';
import {
  SidemenuAnlaeg,
  SidemenuFadoel,
  SidemenuSodavand,
  SidemenuKildevand,
  SidemenuVandSodavand,
  SidemenuAlkohol,
  SidemenuKulsyre,
  SidemenuInfoSider,
  SidemenuOmOs,
  SidemenuLeverandoer,
} from './Sidemenus';


const VisibleSideMenuDisplay = ({ children }) => (
  <Col xs={2}>
    <div style={{ height: '100%' }}>
      <div style={{ position: 'sticky', top: 0 }}>
        {children}
      </div>
    </div>
  </Col>
);

const SideMenuContainer = screenSizeSwitch([[991, () => null], VisibleSideMenuDisplay]);

export default ({
  children,
  menuPicker,
  activeSidemenu,
}) => {
  const [currentSideMenuValue, setSideMenuValue] = useSideMenuContext();
  useEffect(
    () => {
      if (currentSideMenuValue !== menuPicker) {
        setSideMenuValue(menuPicker);
      }
    },
    [menuPicker, setSideMenuValue, currentSideMenuValue],
  );
  useEffect(
    () => () => setSideMenuValue(null),
    [],
  );
  return (
    <React.Fragment>
      <Container>
        <Row padding="0">
          <SideMenuContainer>
            {menuPicker === 'Leverandoer' && (
              <SidemenuLeverandoer
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Sodavand' && (
              <SidemenuSodavand
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Kildevand' && (
              <SidemenuKildevand
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Alkohol' && (
              <SidemenuAlkohol
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'VandSodavand' && (
              <SidemenuVandSodavand
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Fadoel' && (
              <SidemenuFadoel
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Anlaeg' && (
              <SidemenuAnlaeg
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Kulsyre' && (
              <SidemenuKulsyre
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'Infosider' && (
              <SidemenuInfoSider
                activeSidemenu={activeSidemenu}
              />
            )}
            {menuPicker === 'OmOs' && (
              <SidemenuOmOs
                activeSidemenu={activeSidemenu}
              />
            )}
          </SideMenuContainer>
          <Col xs={12} lg={10}>
            <Div>
              {children}
            </Div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row padding="0">
          <Col xs={12}>
            <Div>
              <Footer />
            </Div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
